const notificationRoutes = {
  notifications: {
    path: '/notifications'
  }
};

export default notificationRoutes;
